import React, { useState } from "react";

const LocationPicker = ({ onLocationSelect }) => {
  const [address, setAddress] = useState("");
  const [area, setArea] = useState("");
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);
  const [locating, setLocating] = useState(false);

  const handleLocateMe = () => {
    if (!navigator.geolocation) {
      alert("❌ Geolocation not supported.");
      return;
    }
    setLocating(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        setLat(lat);
        setLng(lng);
        setAddress(`Lat: ${lat.toFixed(3)}, Lon: ${lng.toFixed(3)}`);
        setLocating(false);
        if (onLocationSelect) {
          onLocationSelect({
            address: `Lat: ${lat.toFixed(3)}, Lon: ${lng.toFixed(3)}`,
            area: area,
            lat,
            lng,
          });
        }
      },
      (err) => {
        alert("❌ Failed to get location");
        setLocating(false);
      }
    );
  };

  const handleAddressChange = (e) => {
    setAddress(e.target.value);
    if (onLocationSelect) {
      onLocationSelect({
        address: e.target.value,
        area,
        lat,
        lng,
      });
    }
  };

  const handleAreaChange = (e) => {
    setArea(e.target.value);
    if (onLocationSelect) {
      onLocationSelect({
        address,
        area: e.target.value,
        lat,
        lng,
      });
    }
  };

  return (
    <div className="space-y-2">
      <input
        className="w-full border p-2"
        placeholder="Flat/Street/Landmark"
        value={address}
        onChange={handleAddressChange}
      />
      <input
        className="w-full border p-2"
        placeholder="Area (optional)"
        value={area}
        onChange={handleAreaChange}
      />
      <button
        type="button"
        className="bg-green-600 text-white px-4 py-2 rounded"
        onClick={handleLocateMe}
        disabled={locating}
      >
        {locating ? "Locating..." : "📍 Locate Me"}
      </button>
      {lat && lng && (
        <div className="text-sm text-green-700 mt-1">
          Coordinates: {lat.toFixed(3)}, {lng.toFixed(3)}
        </div>
      )}
    </div>
  );
};

export default LocationPicker; 